"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromiseObservable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _root = require("../util/root");

var _Observable2 = require("../Observable");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(PromiseObservable, _Observable);

  function PromiseObservable(promise, scheduler) {
    var _this;

    (0, _classCallCheck2.default)(this, PromiseObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PromiseObservable).call(this));
    _this.promise = promise;
    _this.scheduler = scheduler;
    return _this;
  }
  /**
   * Converts a Promise to an Observable.
   *
   * <span class="informal">Returns an Observable that just emits the Promise's
   * resolved value, then completes.</span>
   *
   * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
   * Observable. If the Promise resolves with a value, the output Observable
   * emits that resolved value as a `next`, and then completes. If the Promise
   * is rejected, then the output Observable emits the corresponding Error.
   *
   * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
   * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
   * result.subscribe(x => console.log(x), e => console.error(e));
   *
   * @see {@link bindCallback}
   * @see {@link from}
   *
   * @param {PromiseLike<T>} promise The promise to be converted.
   * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
   * the delivery of the resolved value (or the rejection).
   * @return {Observable<T>} An Observable which wraps the Promise.
   * @static true
   * @name fromPromise
   * @owner Observable
   */


  (0, _createClass2.default)(PromiseObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var _this2 = this;

      var promise = this.promise;
      var scheduler = this.scheduler;

      if (scheduler == null) {
        if (this._isScalar) {
          if (!subscriber.closed) {
            subscriber.next(this.value);
            subscriber.complete();
          }
        } else {
          promise.then(function (value) {
            _this2.value = value;
            _this2._isScalar = true;

            if (!subscriber.closed) {
              subscriber.next(value);
              subscriber.complete();
            }
          }, function (err) {
            if (!subscriber.closed) {
              subscriber.error(err);
            }
          }).then(null, function (err) {
            // escape the promise trap, throw unhandled errors
            _root.root.setTimeout(function () {
              throw err;
            });
          });
        }
      } else {
        if (this._isScalar) {
          if (!subscriber.closed) {
            return scheduler.schedule(dispatchNext, 0, {
              value: this.value,
              subscriber: subscriber
            });
          }
        } else {
          promise.then(function (value) {
            _this2.value = value;
            _this2._isScalar = true;

            if (!subscriber.closed) {
              subscriber.add(scheduler.schedule(dispatchNext, 0, {
                value: value,
                subscriber: subscriber
              }));
            }
          }, function (err) {
            if (!subscriber.closed) {
              subscriber.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subscriber: subscriber
              }));
            }
          }).then(null, function (err) {
            // escape the promise trap, throw unhandled errors
            _root.root.setTimeout(function () {
              throw err;
            });
          });
        }
      }
    }
  }], [{
    key: "create",
    value: function create(promise, scheduler) {
      return new PromiseObservable(promise, scheduler);
    }
  }]);
  return PromiseObservable;
}(_Observable2.Observable);

exports.PromiseObservable = PromiseObservable;

function dispatchNext(arg) {
  var value = arg.value,
      subscriber = arg.subscriber;

  if (!subscriber.closed) {
    subscriber.next(value);
    subscriber.complete();
  }
}

function dispatchError(arg) {
  var err = arg.err,
      subscriber = arg.subscriber;

  if (!subscriber.closed) {
    subscriber.error(err);
  }
}